<template>
  <modal
    :title="title"
    large
    :value="show"
    cancelText="Fermer"
    okText="Enregistrer"
    effect="fade/zoom"
    @ok="handleNewClient"
    @cancel="close"
  >
    <loader :is-visible="loading" />

    <div v-if="errors.create" class="alert alert-danger">
      {{ errors.create }}
    </div>

    <template v-if="form">
      <div class="form-group">
        <label>Email</label>
        <input
          v-model="form.email"
          type="email"
          class="form-control"
          :class="{ 'has-error': errors.email }"
          placeholder="exemple : michael@justcoaching.fr"
          autocomplete="off"
          @input="errors.email = null"
        />
        <div v-if="errors.email" class="text-danger">
          {{ errors.email }}
        </div>
      </div>

      <div class="form-group">
        <label>Commercial</label>
        <v-select :options="commercials" v-model="form.commercial"></v-select>
      </div>

      <div class="form-group">
        <label>Concepts</label>
        <multiselect
          v-model="form.concepts"
          :options="concepts"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          label="name"
          track-by="name"
          placeholder="Choisir"
          class="custom-multiselect"
          :class="{ 'has-error': errors.concepts }"
          @input="errors.concepts = null"
        >
        </multiselect>
        <div v-if="errors.concepts" class="text-danger">
          {{ errors.concepts }}
        </div>
      </div>

      <div class="form-group">
        <label>Statut</label>
        <v-select
          v-if="form.prospect"
          :options="prospectStatus"
          :reduce="(status) => status.value"
          v-model="form.prospect.type"
        ></v-select>
        <v-select
          v-else
          :options="clientStatus"
          :reduce="(status) => status.value"
          v-model="form.status"
        ></v-select>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "vue-strap/src/Modal";
import Multiselect from "vue-multiselect";

import Loader from "@/components/utils/Loader";

export default {
  components: {
    Modal,
    Multiselect,
    Loader,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    default: {
      type: Object,
      required: true,
    },

    commercials: {
      type: Array,
      default: () => [],
    },

    concepts: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      loading: false,
      errors: {
        email: null,
        concepts: null,
        create: null,
      },

      form: {
        email: null,
        commercial: null,
        concepts: [],
        prospect: null,
        status: null,
      },
    };
  },

  computed: {
    ...mapGetters({
      prospectStatus: "getProspectStatus",
      clientStatus: "getClientStatus",
    }),

    title() {
      return this.form?.prospect ? "Ajouter un prospect" : "Ajouter un client";
    },
  },

  mounted() {
    this.form = { ...this.form, ...this.default };
  },

  methods: {
    validateForm() {
      this.errors = { ...this.errors, email: null, create: null };

      if (!this.form.email) {
        this.errors.email = "Veuillez renseigner une adresse email";
      }

      if (!this.form.concepts || this.form.concepts.length === 0) {
        this.errors.concepts = "Veuillez sélectionner au moins un concept";
      }

      return !Object.values(this.errors).some((error) => !!error);
    },

    async handleNewClient() {
      const isValidForm = this.validateForm();

      if (!isValidForm) {
        return;
      }

      try {
        this.loading = true;

        const { data } = await this.$api.post("/clients", this.form);

        this.$router.push({
          name: "client-details",
          params: {
            id: data.id,
          },
        });
      } catch (e) {
        this.errors.create = `Une erreur est survenue lors de la création du ${
          this.form.prospect ? "prospect" : "client"
        }`;
      } finally {
        this.loading = false;
      }
    },

    close() {
      this.form = { ...this.default };
      this.errors = {
        email: null,
        concepts: null,
        create: null,
      };

      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.has-error {
  border: 1px solid #ff5454;
  border-radius: 4px;
}
</style>
